<template>
    <div class="campos-obrigatorios-editor">
        <div style="color: #909399; font-size: 12px; margin-bottom: 10px;">
            Marque os campos que devem ser <b>obrigatórios</b> no formulário. Os demais ficam opcionais.
        </div>

        <el-row :gutter="10">
            <el-col v-for="c in catalogo" :key="c.key" :xs="24" :sm="12" :md="8">
                <div class="campo-row">
                    <el-switch
                        :value="estaObrigatorio(c.key)"
                        @change="toggle(c.key, $event)"
                        active-color="#13ce66">
                    </el-switch>
                    <span class="campo-label" :class="{ 'is-obrigatorio': estaObrigatorio(c.key) }">{{ c.label }}</span>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { CAMPOS_ALUNO, CAMPOS_SERVIDOR, CHAVE_CAMPOS_SERVIDOR } from '@/shared/constants/camposObrigatorios'

export default {
    name: 'CamposObrigatoriosEditor',
    props: {
        p: { type: Object, required: true },
        valor: { default: null }
    },
    data () {
        return { obrigatorios: [] }
    },
    computed: {
        catalogo () {
            return this.p.chave === CHAVE_CAMPOS_SERVIDOR ? CAMPOS_SERVIDOR : CAMPOS_ALUNO
        }
    },
    watch: {
        valor: { immediate: true, handler (v) { this.obrigatorios = this.parse(v) } }
    },
    methods: {
        parse (v) {
            if (!v) return []
            try {
                const arr = typeof v === 'string' ? JSON.parse(v) : v
                return Array.isArray(arr) ? arr : []
            } catch (e) { return [] }
        },
        estaObrigatorio (key) {
            return this.obrigatorios.includes(key)
        },
        toggle (key, marcado) {
            const set = new Set(this.obrigatorios)
            if (marcado) set.add(key)
            else set.delete(key)
            this.obrigatorios = Array.from(set)
            this.$emit('save', this.obrigatorios)
        }
    }
}
</script>

<style scoped>
.campo-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 4px;
    border-bottom: 1px solid #f5f5f5;
}
.campo-label {
    font-size: 13px;
    color: #606266;
}
.campo-label.is-obrigatorio {
    color: #303133;
    font-weight: 600;
}
</style>
